// @flow

const convertLatLngsToCoordinates = (
  coverage: Array<Object>
): Array<Object> => {
  return coverage.map(point => ({
    latitude: point.lat,
    longitude: point.lng
  }))
}

function convertCoordinatesToLatLng(coverage: Array<Object>): Array<Object> {
  return coverage.map(coordinate => ({
    lat: coordinate.latitude,
    lng: coordinate.longitude
  }))
}

export { convertLatLngsToCoordinates, convertCoordinatesToLatLng }
